import { render, staticRenderFns } from "./Ypcjxx.vue?vue&type=template&id=47641153&scoped=true"
import script from "./Ypcjxx.vue?vue&type=script&lang=js"
export * from "./Ypcjxx.vue?vue&type=script&lang=js"
import style0 from "./Ypcjxx.vue?vue&type=style&index=0&id=47641153&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47641153",
  null
  
)

export default component.exports